export const AZURE_SUBS_REGEX = new RegExp("^/cloud-providers/azure/subscriptions/[^/]+$");
